<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />
    <Loading v-show="loading" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Loading from '@c/Loading';
import tracker from '@/util/tracker';
import { CID } from '@/constants/statistics';

export default {
  name: 'App',
  components: {
    Loading,
  },
  computed: {
    ...mapState(['loading']),
  },
  watch: {
    $route(route) {
      tracker.dealWithPageChange(CID[route.name]);
    },
  },
};
</script>

<style>
#app {
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
}
</style>
